<template>
  <div class="service">
    <div class="layout__content__header layout__content__header--white">
      <app-back :text="'naDashboard'" />
      <h1 v-if="service">
        {{ service.custServiceName }}
      </h1>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Back from "@/components/back.vue";

export default {
  components: {
    "app-back": Back
  },
  data() {
    return {
      serviceId: this.$route.params.id,
      service: this.$route.params.service,
      props: {
        service: Object
      }
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale() {
      //this.loadArticle();
    }
  },
  created() {
    //this.loadArticle();
  },
  mounted() {},
  methods: {
    loadArticle() {
      axios
        .get(
          process.env.VUE_APP_APICMS +
            "/" +
            this.locale +
            "/article" +
            this.articleUrl,
          {
            crossdomain: true
          }
        )
        .then(response => {
          this.item = response.data[0];
        })
        .catch(() => {
          this.item = {};
        });
    }
  }
};
</script>

<style scoped></style>
